export const none = () => {
    return () => {
        return {};
    };
};
